document.addEventListener('DOMContentLoaded', function() {
  const firstNavItem = document.querySelector('.er-help-category-nav .e-filter-item');
  const listing = document.querySelector('.er-help-loop');
  
  if (firstNavItem) {
    setTimeout(() => {
      // Triger click
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      });
      firstNavItem.dispatchEvent(clickEvent);
      listing.classList.remove('init');
    }, 500)    
  }

  const helpSearchForm = document.querySelector('.er-help-search .e-search-form');
  if (helpSearchForm) {
    helpSearchForm.setAttribute('action', window.location.href);
  }

});